var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black and White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USD Coin (USDC)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 26.981C20.9558 26.981 27 20.9411 27 13.4905C27 6.0399 20.9558 0 13.5 0C6.04416 0 0 6.0399 0 13.4905C0 20.9411 6.04416 26.981 13.5 26.981Z",
    fill: "url(#paint0_linear_3269_4187)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 427320351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M19.443 7.58021C19.443 7.89423 19.3614 8.12873 19.1981 8.2837C19.0349 8.43459 18.8063 8.51004 18.5125 8.51004C18.2187 8.51004 17.9901 8.43459 17.8269 8.2837C17.6637 8.12873 17.582 7.89423 17.582 7.58021C17.582 7.25396 17.6637 7.01743 17.8269 6.87061C17.9901 6.7238 18.2187 6.65039 18.5125 6.65039C18.8268 6.65039 19.0594 6.7238 19.2104 6.87061C19.3655 7.01743 19.443 7.25396 19.443 7.58021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18521",
    x: 11.9976,
    y: 12.7656,
    width: 6.03262,
    height: 1.2937,
    transform: "rotate(-180 11.9976 12.7656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18522",
    x: 11.9976,
    y: 15.3594,
    width: 6.03262,
    height: 1.2937,
    transform: "rotate(-180 11.9976 15.3594)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9877 10.0168C17.8228 10.158 17.7404 10.3698 17.7404 10.6522V15.6946H19.4358V10.6522C19.4358 10.3698 19.3416 10.158 19.1532 10.0168C18.9648 9.87566 18.7765 9.80507 18.5881 9.80507C18.3762 9.80507 18.176 9.87566 17.9877 10.0168ZM19.3993 16.4948C19.3089 17.4442 19.0503 18.262 18.6234 18.9482C18.0818 19.7953 17.3754 20.4307 16.5042 20.8542C15.6565 21.2542 14.75 21.4542 13.7845 21.4542C12.1598 21.4542 10.8059 20.9836 9.72271 20.0424C8.66311 19.0777 8.1333 17.6188 8.1333 15.6658V7.65373C8.1333 7.37137 8.21571 7.1596 8.38054 7.01841C8.56892 6.87723 8.76907 6.80664 8.98099 6.80664C9.19291 6.80664 9.38128 6.87723 9.54611 7.01841C9.73449 7.1596 9.82867 7.37137 9.82867 7.65373V15.7364C9.82867 17.1717 10.1819 18.2423 10.8883 18.9482C11.5947 19.6542 12.5601 20.0071 13.7845 20.0071C14.8912 20.0071 15.8213 19.6659 16.5748 18.9835C17.2153 18.4017 17.5918 17.5721 17.7044 16.4948H19.3993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18523",
    x: 8.13867,
    y: 6.81445,
    width: 1.69501,
    height: 1.84052,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18524",
    x: 17.7461,
    y: 9.62891,
    width: 1.69501,
    height: 1.84052,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3269_4187",
    x1: 4.19748,
    y1: 5.46155,
    x2: 21.3806,
    y2: 25.3392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55AD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6CE3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00997B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdi);
export default __webpack_public_path__ + "static/media/usdi.5061356ef920670b2c35c41caea74477.svg";
export { ForwardRef as ReactComponent };